<template>
  <div>
    <Head title="Paneli" />

    <div class="flex flex-wrap mx-2 mb-6 lg:mb-6">
      <h3 class="text-sm font-bold pr-6 w-full lg:w-full">Dërgesa
        <hr></h3>
      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`dergesat?status_ids[]=1`">{{this.ordersData.created}}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të regjistruara</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5  mr-5 mt-2  w-full lg:w-1/6 bg-indigo-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`dergesat?status_ids[]=2`">{{ this.ordersData.processing }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në proces</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-orange-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`dergesat?status_ids[]=3`">{{ this.ordersData.warehouse }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në depo</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-red-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`dergesat?status_ids[]=7`">{{ this.ordersData.cancelled }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të anuluara</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-gray-400 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`dergesat?status_ids[]=8`">{{ this.ordersData.returned }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të kthyera</h1>
      </div>
    </div>




    <div class="flex flex-wrap mx-2 mb-6 lg:mb-6">
      <h3 class="text-sm font-bold pr-6 w-full lg:w-full">Barazime
        <hr></h3>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link href="barazimet-me-shites?status_id=1">{{this.barazimsData.created}}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të regjistruara</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-orange-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`barazimet-me-shites?status_id=2`">{{ this.barazimsData.warehouse }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në depo</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-indigo-900 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`barazimet-me-shites?status_id=3`">{{ this.barazimsData.shipping }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në shpërndarje</h1>
      </div>


      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-700 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`barazimet-me-shites?status_id=6`">{{ this.barazimsData.pending }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në pritje</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-green-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`barazimet-me-shites?status_id=4`">{{ this.barazimsData.delivered }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Sukses</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-red-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="`barazimet-me-shites?status_id=5`">{{ this.barazimsData.failed }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Dështim</h1>
      </div>
    </div>




    <div class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div class="overflow-hidden w-full lg:w-1/2">

        <div class="ml-5 mb-5 mt-5 flex items-center">
          <h2 class="text-2xl font-bold">Bizneset</h2>
        </div>

        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full">
            <thead>
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-2">Emri i biznesit</th>
              <th class="pb-4 pt-6 px-2">Të regjistruara</th>
              <th class="pb-4 pt-6 px-2">Në proces</th>
              <th class="pb-4 pt-6 px-2">Në depo</th>
              <th class="pb-4 pt-6 px-2">Të anuluara</th>
              <th class="pb-4 pt-6 px-2">Të kthyera</th>
              <th class="pb-4 pt-6 px-2">Gjithsejt</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="businessData in businessesData" class="hover:bg-gray-100 focus-within:bg-gray-100">

              <td class="border-t px-2 py-2">
                {{ businessData.business_name }}
              </td>
              <td class="border-t px-2">
                {{ businessData.created }}
              </td>
              <td class="border-t px-2">
                {{ businessData.processing }}
              </td>
              <td class="border-t px-2">
                {{ businessData.warehouse }}
              </td>
              <td class="border-t px-2">
                {{ businessData.cancelled }}
              </td>
              <td class="border-t px-2">
                {{ businessData.returned }}
              </td>
              <td class="border-t px-2">
                {{ businessData.created + businessData.processing + businessData.warehouse + businessData.cancelled + businessData.returned }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Link
  },
  layout: Layout,
  props: {
    ordersData: Object,
    barazimsData: Object,
    businessesData: Object
  },
}
</script>
